import { Checkbox } from "primereact/checkbox";

interface WhimsyToggleMenuItemProps {
  isWhimsyVisible: boolean;
  toggleWhimsyVisibility: () => void;
}

export function WhimsyToggleMenuItem({
  isWhimsyVisible,
  toggleWhimsyVisibility,
}: WhimsyToggleMenuItemProps) {
  return (
    <div className="px-4 py-3">
      <div className="flex items-center gap-2">
        <Checkbox
          inputId="whimsy-toggle"
          checked={isWhimsyVisible}
          onChange={toggleWhimsyVisibility}
          data-test-id="whimsy-toggle"
        />
        <label htmlFor="whimsy-toggle" className="cursor-pointer text-sm">
          Show Whimsy
        </label>
      </div>
    </div>
  );
}
